<div>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Error Details:</h4>
        <button type="button" class="btn-close" aria-label="Close"(click)="activeModal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body"> 
                        <ul>
                            <li *ngFor="let error of cellData" style="color: #ff3333;">
                                {{ error.message }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>